import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { uuidish } from '../../utils/uuidish.js';
export const exportEventTypeSchema = z.enum(['docx', 'json', 'faro-standard-json-format']);
export const exportEventBodySchema = z.object({
    userId: uuidish,
    studyId: uuidish,
    exportType: exportEventTypeSchema,
    studyRevision: z.number(),
    description: z.string(),
});
export function toExportEventBody(exportEventBody) {
    const result = exportEventBodySchema.safeParse(exportEventBody);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid ExportEventBody object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=export-event-body.js.map